export function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function requirePlainObject(value, label) {
  if (!isPlainObject(value)) {
    throw new Error(`${label} must be an object.`);
  }
  return value;
}

export function requireArray(value, label) {
  if (!Array.isArray(value)) {
    throw new Error(`${label} must be an array.`);
  }
  return value;
}

export function requireString(value, label) {
  if (typeof value !== "string") {
    throw new Error(`${label} must be a string.`);
  }
  return value;
}

export function requireNonEmptyString(value, label) {
  const stringValue = requireString(value, label).trim();
  if (!stringValue) {
    throw new Error(`${label} is required.`);
  }
  return stringValue;
}

export function requirePositiveInteger(value, label) {
  const numericValue = Number(value);
  if (!Number.isInteger(numericValue) || numericValue <= 0) {
    throw new Error(`${label} must be a positive integer.`);
  }
  return numericValue;
}

export function requireNonNegativeInteger(value, label) {
  const numericValue = Number(value);
  if (!Number.isInteger(numericValue) || numericValue < 0) {
    throw new Error(`${label} must be a non-negative integer.`);
  }
  return numericValue;
}

export function requireFiniteNumber(value, label) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    throw new Error(`${label} must be a finite number.`);
  }
  return numericValue;
}

export function parseOptionalFiniteNumber(value, label) {
  if (value == null) {
    return null;
  }
  if (typeof value === "string" && value.trim() === "") {
    return null;
  }
  return requireFiniteNumber(value, label);
}

export function parseOptionalString(value, label) {
  if (value == null) {
    return null;
  }
  const stringValue = requireString(value, label).trim();
  return stringValue === "" ? null : stringValue;
}

export function requireResponsePayload(response, label) {
  const normalizedResponse = requirePlainObject(response, `${label} response`);
  return requirePlainObject(normalizedResponse.data, `${label} response data`);
}

export function requireResponseArrayPayload(response, label) {
  const normalizedResponse = requirePlainObject(response, `${label} response`);
  return requireArray(normalizedResponse.data, `${label} response data`);
}
